import { render } from "./CheckoutTestimonials.vue?vue&type=template&id=2ddce6c0"
import script from "./CheckoutTestimonials.vue?vue&type=script&lang=js"
export * from "./CheckoutTestimonials.vue?vue&type=script&lang=js"

import "./CheckoutTestimonials.vue?vue&type=style&index=0&id=2ddce6c0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__